// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/CommandModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Any } from "../../../google/protobuf/any";
import { StringValue } from "../../../google/protobuf/wrappers";
import { AIModel, Settings } from "./SettingsModels";

export const protobufPackage = "daisi.protos.v1";

export interface Command {
  Name: string;
  Message?: string | undefined;
  Payload?: Any | undefined;
  SessionId?: string | undefined;
  RequestId?: string | undefined;
}

export interface CommandParameter {
  Key: string;
  Value: string;
}

export interface HeartbeatRequest {
  Settings?: Settings | undefined;
}

export interface EnvironmentRequest {
  OperatingSystem: string;
  OperatingSystemVersion: string;
  AppVersion: string;
}

export interface UpdateRequiredRequest {
  HostAppUrl?: string | undefined;
  Channel?: string | undefined;
}

export interface MoveOrcRequest {
  Domain: string;
  Port: number;
  UseSSL: boolean;
}

export interface ShowMessageRequest {
  Id: string;
  Parts: MessagePart[];
}

export interface ShowMessageResponse {
  Id: string;
  Parts: MessagePartResponse[];
}

export interface CancelStreamRequest {
}

export interface MessagePart {
  Name: string;
  Label: string;
  Values: string[];
  Type: string;
  Optional: boolean;
}

export interface MessagePartResponse {
  Name: string;
  Values: string[];
}

export interface VectorDbAssignRequest {
  AccountId: string;
  FileIds: string[];
}

export interface VectorDbReleaseRequest {
  AccountId: string;
}

export interface PeerShardTransferRequest {
  ShardId: string;
  TargetHostIp: string;
  TargetHostPort: number;
}

export interface ExecuteToolRequest {
  ToolId: string;
  Parameters: ToolParam[];
  RequestingHostId: string;
  SessionId: string;
  RequestId: string;
}

export interface ToolParam {
  Name: string;
  Value: string;
}

export interface ExecuteToolResponse {
  Success: boolean;
  Output: string;
  ErrorMessage: string;
  OutputMessage: string;
  OutputFormat: string;
}

export interface DownloadModelRequest {
  Model?: AIModel | undefined;
}

export interface DownloadModelResponse {
  Success: boolean;
  ErrorMessage: string;
}

export interface RemoveModelRequest {
  ModelId: string;
  ModelName: string;
  FileName: string;
}

export interface RemoveModelResponse {
  Success: boolean;
  ErrorMessage: string;
}

/** MCP Sync commands (sent from ORC to Host) */
export interface McpSyncRequest {
  AccountId: string;
  ServerId: string;
  ServerUrl: string;
  AuthType: string;
  AuthSecret: string;
  RepositoryId: string;
  CreatedByUserId: string;
  EnabledResources: McpEnabledResource[];
}

export interface McpEnabledResource {
  Uri: string;
  Name: string;
  MimeType: string;
}

export interface McpSyncResponse {
  ServerId: string;
  Success: boolean;
  Error: string;
  ResourcesSynced: number;
  DiscoveredResources: McpSyncDiscoveredResource[];
}

export interface McpSyncDiscoveredResource {
  Uri: string;
  Name: string;
  MimeType: string;
  Description: string;
}

/** Browser-compatible command RPCs */
export interface ListenForCommandsRequest {
}

export interface SendCommandRequest {
  Command?: Command | undefined;
}

export interface SendCommandResponse {
  Success: boolean;
}

function createBaseCommand(): Command {
  return { Name: "", Message: undefined, Payload: undefined, SessionId: undefined, RequestId: undefined };
}

export const Command: MessageFns<Command> = {
  encode(message: Command, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Name !== "") {
      writer.uint32(10).string(message.Name);
    }
    if (message.Message !== undefined) {
      StringValue.encode({ value: message.Message! }, writer.uint32(18).fork()).join();
    }
    if (message.Payload !== undefined) {
      Any.encode(message.Payload, writer.uint32(26).fork()).join();
    }
    if (message.SessionId !== undefined) {
      StringValue.encode({ value: message.SessionId! }, writer.uint32(34).fork()).join();
    }
    if (message.RequestId !== undefined) {
      StringValue.encode({ value: message.RequestId! }, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Command {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommand();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Message = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Payload = Any.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.SessionId = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.RequestId = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Command {
    return {
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      Message: isSet(object.Message) ? String(object.Message) : undefined,
      Payload: isSet(object.Payload) ? Any.fromJSON(object.Payload) : undefined,
      SessionId: isSet(object.SessionId) ? String(object.SessionId) : undefined,
      RequestId: isSet(object.RequestId) ? String(object.RequestId) : undefined,
    };
  },

  toJSON(message: Command): unknown {
    const obj: any = {};
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.Message !== undefined) {
      obj.Message = message.Message;
    }
    if (message.Payload !== undefined) {
      obj.Payload = Any.toJSON(message.Payload);
    }
    if (message.SessionId !== undefined) {
      obj.SessionId = message.SessionId;
    }
    if (message.RequestId !== undefined) {
      obj.RequestId = message.RequestId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Command>, I>>(base?: I): Command {
    return Command.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Command>, I>>(object: I): Command {
    const message = createBaseCommand();
    message.Name = object.Name ?? "";
    message.Message = object.Message ?? undefined;
    message.Payload = (object.Payload !== undefined && object.Payload !== null)
      ? Any.fromPartial(object.Payload)
      : undefined;
    message.SessionId = object.SessionId ?? undefined;
    message.RequestId = object.RequestId ?? undefined;
    return message;
  },
};

function createBaseCommandParameter(): CommandParameter {
  return { Key: "", Value: "" };
}

export const CommandParameter: MessageFns<CommandParameter> = {
  encode(message: CommandParameter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Key !== "") {
      writer.uint32(10).string(message.Key);
    }
    if (message.Value !== "") {
      writer.uint32(18).string(message.Value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommandParameter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommandParameter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommandParameter {
    return {
      Key: isSet(object.Key) ? globalThis.String(object.Key) : "",
      Value: isSet(object.Value) ? globalThis.String(object.Value) : "",
    };
  },

  toJSON(message: CommandParameter): unknown {
    const obj: any = {};
    if (message.Key !== "") {
      obj.Key = message.Key;
    }
    if (message.Value !== "") {
      obj.Value = message.Value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CommandParameter>, I>>(base?: I): CommandParameter {
    return CommandParameter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommandParameter>, I>>(object: I): CommandParameter {
    const message = createBaseCommandParameter();
    message.Key = object.Key ?? "";
    message.Value = object.Value ?? "";
    return message;
  },
};

function createBaseHeartbeatRequest(): HeartbeatRequest {
  return { Settings: undefined };
}

export const HeartbeatRequest: MessageFns<HeartbeatRequest> = {
  encode(message: HeartbeatRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Settings !== undefined) {
      Settings.encode(message.Settings, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HeartbeatRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeartbeatRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Settings = Settings.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HeartbeatRequest {
    return { Settings: isSet(object.Settings) ? Settings.fromJSON(object.Settings) : undefined };
  },

  toJSON(message: HeartbeatRequest): unknown {
    const obj: any = {};
    if (message.Settings !== undefined) {
      obj.Settings = Settings.toJSON(message.Settings);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<HeartbeatRequest>, I>>(base?: I): HeartbeatRequest {
    return HeartbeatRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<HeartbeatRequest>, I>>(object: I): HeartbeatRequest {
    const message = createBaseHeartbeatRequest();
    message.Settings = (object.Settings !== undefined && object.Settings !== null)
      ? Settings.fromPartial(object.Settings)
      : undefined;
    return message;
  },
};

function createBaseEnvironmentRequest(): EnvironmentRequest {
  return { OperatingSystem: "", OperatingSystemVersion: "", AppVersion: "" };
}

export const EnvironmentRequest: MessageFns<EnvironmentRequest> = {
  encode(message: EnvironmentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.OperatingSystem !== "") {
      writer.uint32(10).string(message.OperatingSystem);
    }
    if (message.OperatingSystemVersion !== "") {
      writer.uint32(18).string(message.OperatingSystemVersion);
    }
    if (message.AppVersion !== "") {
      writer.uint32(26).string(message.AppVersion);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnvironmentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnvironmentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.OperatingSystem = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.OperatingSystemVersion = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.AppVersion = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnvironmentRequest {
    return {
      OperatingSystem: isSet(object.OperatingSystem) ? globalThis.String(object.OperatingSystem) : "",
      OperatingSystemVersion: isSet(object.OperatingSystemVersion)
        ? globalThis.String(object.OperatingSystemVersion)
        : "",
      AppVersion: isSet(object.AppVersion) ? globalThis.String(object.AppVersion) : "",
    };
  },

  toJSON(message: EnvironmentRequest): unknown {
    const obj: any = {};
    if (message.OperatingSystem !== "") {
      obj.OperatingSystem = message.OperatingSystem;
    }
    if (message.OperatingSystemVersion !== "") {
      obj.OperatingSystemVersion = message.OperatingSystemVersion;
    }
    if (message.AppVersion !== "") {
      obj.AppVersion = message.AppVersion;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EnvironmentRequest>, I>>(base?: I): EnvironmentRequest {
    return EnvironmentRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EnvironmentRequest>, I>>(object: I): EnvironmentRequest {
    const message = createBaseEnvironmentRequest();
    message.OperatingSystem = object.OperatingSystem ?? "";
    message.OperatingSystemVersion = object.OperatingSystemVersion ?? "";
    message.AppVersion = object.AppVersion ?? "";
    return message;
  },
};

function createBaseUpdateRequiredRequest(): UpdateRequiredRequest {
  return { HostAppUrl: undefined, Channel: undefined };
}

export const UpdateRequiredRequest: MessageFns<UpdateRequiredRequest> = {
  encode(message: UpdateRequiredRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.HostAppUrl !== undefined) {
      StringValue.encode({ value: message.HostAppUrl! }, writer.uint32(10).fork()).join();
    }
    if (message.Channel !== undefined) {
      StringValue.encode({ value: message.Channel! }, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateRequiredRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateRequiredRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.HostAppUrl = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Channel = StringValue.decode(reader, reader.uint32()).value;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateRequiredRequest {
    return {
      HostAppUrl: isSet(object.HostAppUrl) ? String(object.HostAppUrl) : undefined,
      Channel: isSet(object.Channel) ? String(object.Channel) : undefined,
    };
  },

  toJSON(message: UpdateRequiredRequest): unknown {
    const obj: any = {};
    if (message.HostAppUrl !== undefined) {
      obj.HostAppUrl = message.HostAppUrl;
    }
    if (message.Channel !== undefined) {
      obj.Channel = message.Channel;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateRequiredRequest>, I>>(base?: I): UpdateRequiredRequest {
    return UpdateRequiredRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateRequiredRequest>, I>>(object: I): UpdateRequiredRequest {
    const message = createBaseUpdateRequiredRequest();
    message.HostAppUrl = object.HostAppUrl ?? undefined;
    message.Channel = object.Channel ?? undefined;
    return message;
  },
};

function createBaseMoveOrcRequest(): MoveOrcRequest {
  return { Domain: "", Port: 0, UseSSL: false };
}

export const MoveOrcRequest: MessageFns<MoveOrcRequest> = {
  encode(message: MoveOrcRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Domain !== "") {
      writer.uint32(10).string(message.Domain);
    }
    if (message.Port !== 0) {
      writer.uint32(16).int32(message.Port);
    }
    if (message.UseSSL !== false) {
      writer.uint32(24).bool(message.UseSSL);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MoveOrcRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMoveOrcRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Domain = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.Port = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.UseSSL = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MoveOrcRequest {
    return {
      Domain: isSet(object.Domain) ? globalThis.String(object.Domain) : "",
      Port: isSet(object.Port) ? globalThis.Number(object.Port) : 0,
      UseSSL: isSet(object.UseSSL) ? globalThis.Boolean(object.UseSSL) : false,
    };
  },

  toJSON(message: MoveOrcRequest): unknown {
    const obj: any = {};
    if (message.Domain !== "") {
      obj.Domain = message.Domain;
    }
    if (message.Port !== 0) {
      obj.Port = Math.round(message.Port);
    }
    if (message.UseSSL !== false) {
      obj.UseSSL = message.UseSSL;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MoveOrcRequest>, I>>(base?: I): MoveOrcRequest {
    return MoveOrcRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MoveOrcRequest>, I>>(object: I): MoveOrcRequest {
    const message = createBaseMoveOrcRequest();
    message.Domain = object.Domain ?? "";
    message.Port = object.Port ?? 0;
    message.UseSSL = object.UseSSL ?? false;
    return message;
  },
};

function createBaseShowMessageRequest(): ShowMessageRequest {
  return { Id: "", Parts: [] };
}

export const ShowMessageRequest: MessageFns<ShowMessageRequest> = {
  encode(message: ShowMessageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    for (const v of message.Parts) {
      MessagePart.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ShowMessageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseShowMessageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Parts.push(MessagePart.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ShowMessageRequest {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      Parts: globalThis.Array.isArray(object?.Parts) ? object.Parts.map((e: any) => MessagePart.fromJSON(e)) : [],
    };
  },

  toJSON(message: ShowMessageRequest): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.Parts?.length) {
      obj.Parts = message.Parts.map((e) => MessagePart.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ShowMessageRequest>, I>>(base?: I): ShowMessageRequest {
    return ShowMessageRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ShowMessageRequest>, I>>(object: I): ShowMessageRequest {
    const message = createBaseShowMessageRequest();
    message.Id = object.Id ?? "";
    message.Parts = object.Parts?.map((e) => MessagePart.fromPartial(e)) || [];
    return message;
  },
};

function createBaseShowMessageResponse(): ShowMessageResponse {
  return { Id: "", Parts: [] };
}

export const ShowMessageResponse: MessageFns<ShowMessageResponse> = {
  encode(message: ShowMessageResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    for (const v of message.Parts) {
      MessagePartResponse.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ShowMessageResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseShowMessageResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Parts.push(MessagePartResponse.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ShowMessageResponse {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      Parts: globalThis.Array.isArray(object?.Parts)
        ? object.Parts.map((e: any) => MessagePartResponse.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ShowMessageResponse): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.Parts?.length) {
      obj.Parts = message.Parts.map((e) => MessagePartResponse.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ShowMessageResponse>, I>>(base?: I): ShowMessageResponse {
    return ShowMessageResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ShowMessageResponse>, I>>(object: I): ShowMessageResponse {
    const message = createBaseShowMessageResponse();
    message.Id = object.Id ?? "";
    message.Parts = object.Parts?.map((e) => MessagePartResponse.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCancelStreamRequest(): CancelStreamRequest {
  return {};
}

export const CancelStreamRequest: MessageFns<CancelStreamRequest> = {
  encode(_: CancelStreamRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CancelStreamRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCancelStreamRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): CancelStreamRequest {
    return {};
  },

  toJSON(_: CancelStreamRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CancelStreamRequest>, I>>(base?: I): CancelStreamRequest {
    return CancelStreamRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CancelStreamRequest>, I>>(_: I): CancelStreamRequest {
    const message = createBaseCancelStreamRequest();
    return message;
  },
};

function createBaseMessagePart(): MessagePart {
  return { Name: "", Label: "", Values: [], Type: "", Optional: false };
}

export const MessagePart: MessageFns<MessagePart> = {
  encode(message: MessagePart, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Name !== "") {
      writer.uint32(10).string(message.Name);
    }
    if (message.Label !== "") {
      writer.uint32(18).string(message.Label);
    }
    for (const v of message.Values) {
      StringValue.encode({ value: v!! }, writer.uint32(26).fork()).join();
    }
    if (message.Type !== "") {
      writer.uint32(34).string(message.Type);
    }
    if (message.Optional !== false) {
      writer.uint32(40).bool(message.Optional);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessagePart {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessagePart();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Label = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Values.push(StringValue.decode(reader, reader.uint32()).value);
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.Type = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.Optional = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessagePart {
    return {
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      Label: isSet(object.Label) ? globalThis.String(object.Label) : "",
      Values: globalThis.Array.isArray(object?.Values) ? object.Values.map((e: any) => String(e)) : [],
      Type: isSet(object.Type) ? globalThis.String(object.Type) : "",
      Optional: isSet(object.Optional) ? globalThis.Boolean(object.Optional) : false,
    };
  },

  toJSON(message: MessagePart): unknown {
    const obj: any = {};
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.Label !== "") {
      obj.Label = message.Label;
    }
    if (message.Values?.length) {
      obj.Values = message.Values;
    }
    if (message.Type !== "") {
      obj.Type = message.Type;
    }
    if (message.Optional !== false) {
      obj.Optional = message.Optional;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MessagePart>, I>>(base?: I): MessagePart {
    return MessagePart.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MessagePart>, I>>(object: I): MessagePart {
    const message = createBaseMessagePart();
    message.Name = object.Name ?? "";
    message.Label = object.Label ?? "";
    message.Values = object.Values?.map((e) => e) || [];
    message.Type = object.Type ?? "";
    message.Optional = object.Optional ?? false;
    return message;
  },
};

function createBaseMessagePartResponse(): MessagePartResponse {
  return { Name: "", Values: [] };
}

export const MessagePartResponse: MessageFns<MessagePartResponse> = {
  encode(message: MessagePartResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Name !== "") {
      writer.uint32(10).string(message.Name);
    }
    for (const v of message.Values) {
      StringValue.encode({ value: v!! }, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessagePartResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessagePartResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Values.push(StringValue.decode(reader, reader.uint32()).value);
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessagePartResponse {
    return {
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      Values: globalThis.Array.isArray(object?.Values) ? object.Values.map((e: any) => String(e)) : [],
    };
  },

  toJSON(message: MessagePartResponse): unknown {
    const obj: any = {};
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.Values?.length) {
      obj.Values = message.Values;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MessagePartResponse>, I>>(base?: I): MessagePartResponse {
    return MessagePartResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MessagePartResponse>, I>>(object: I): MessagePartResponse {
    const message = createBaseMessagePartResponse();
    message.Name = object.Name ?? "";
    message.Values = object.Values?.map((e) => e) || [];
    return message;
  },
};

function createBaseVectorDbAssignRequest(): VectorDbAssignRequest {
  return { AccountId: "", FileIds: [] };
}

export const VectorDbAssignRequest: MessageFns<VectorDbAssignRequest> = {
  encode(message: VectorDbAssignRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    for (const v of message.FileIds) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VectorDbAssignRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVectorDbAssignRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.FileIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VectorDbAssignRequest {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      FileIds: globalThis.Array.isArray(object?.FileIds) ? object.FileIds.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: VectorDbAssignRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.FileIds?.length) {
      obj.FileIds = message.FileIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VectorDbAssignRequest>, I>>(base?: I): VectorDbAssignRequest {
    return VectorDbAssignRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VectorDbAssignRequest>, I>>(object: I): VectorDbAssignRequest {
    const message = createBaseVectorDbAssignRequest();
    message.AccountId = object.AccountId ?? "";
    message.FileIds = object.FileIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseVectorDbReleaseRequest(): VectorDbReleaseRequest {
  return { AccountId: "" };
}

export const VectorDbReleaseRequest: MessageFns<VectorDbReleaseRequest> = {
  encode(message: VectorDbReleaseRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VectorDbReleaseRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVectorDbReleaseRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VectorDbReleaseRequest {
    return { AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "" };
  },

  toJSON(message: VectorDbReleaseRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VectorDbReleaseRequest>, I>>(base?: I): VectorDbReleaseRequest {
    return VectorDbReleaseRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VectorDbReleaseRequest>, I>>(object: I): VectorDbReleaseRequest {
    const message = createBaseVectorDbReleaseRequest();
    message.AccountId = object.AccountId ?? "";
    return message;
  },
};

function createBasePeerShardTransferRequest(): PeerShardTransferRequest {
  return { ShardId: "", TargetHostIp: "", TargetHostPort: 0 };
}

export const PeerShardTransferRequest: MessageFns<PeerShardTransferRequest> = {
  encode(message: PeerShardTransferRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ShardId !== "") {
      writer.uint32(10).string(message.ShardId);
    }
    if (message.TargetHostIp !== "") {
      writer.uint32(18).string(message.TargetHostIp);
    }
    if (message.TargetHostPort !== 0) {
      writer.uint32(24).int32(message.TargetHostPort);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PeerShardTransferRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePeerShardTransferRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ShardId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.TargetHostIp = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.TargetHostPort = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PeerShardTransferRequest {
    return {
      ShardId: isSet(object.ShardId) ? globalThis.String(object.ShardId) : "",
      TargetHostIp: isSet(object.TargetHostIp) ? globalThis.String(object.TargetHostIp) : "",
      TargetHostPort: isSet(object.TargetHostPort) ? globalThis.Number(object.TargetHostPort) : 0,
    };
  },

  toJSON(message: PeerShardTransferRequest): unknown {
    const obj: any = {};
    if (message.ShardId !== "") {
      obj.ShardId = message.ShardId;
    }
    if (message.TargetHostIp !== "") {
      obj.TargetHostIp = message.TargetHostIp;
    }
    if (message.TargetHostPort !== 0) {
      obj.TargetHostPort = Math.round(message.TargetHostPort);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PeerShardTransferRequest>, I>>(base?: I): PeerShardTransferRequest {
    return PeerShardTransferRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PeerShardTransferRequest>, I>>(object: I): PeerShardTransferRequest {
    const message = createBasePeerShardTransferRequest();
    message.ShardId = object.ShardId ?? "";
    message.TargetHostIp = object.TargetHostIp ?? "";
    message.TargetHostPort = object.TargetHostPort ?? 0;
    return message;
  },
};

function createBaseExecuteToolRequest(): ExecuteToolRequest {
  return { ToolId: "", Parameters: [], RequestingHostId: "", SessionId: "", RequestId: "" };
}

export const ExecuteToolRequest: MessageFns<ExecuteToolRequest> = {
  encode(message: ExecuteToolRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ToolId !== "") {
      writer.uint32(10).string(message.ToolId);
    }
    for (const v of message.Parameters) {
      ToolParam.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.RequestingHostId !== "") {
      writer.uint32(26).string(message.RequestingHostId);
    }
    if (message.SessionId !== "") {
      writer.uint32(34).string(message.SessionId);
    }
    if (message.RequestId !== "") {
      writer.uint32(42).string(message.RequestId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecuteToolRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExecuteToolRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ToolId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Parameters.push(ToolParam.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.RequestingHostId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.SessionId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.RequestId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExecuteToolRequest {
    return {
      ToolId: isSet(object.ToolId) ? globalThis.String(object.ToolId) : "",
      Parameters: globalThis.Array.isArray(object?.Parameters)
        ? object.Parameters.map((e: any) => ToolParam.fromJSON(e))
        : [],
      RequestingHostId: isSet(object.RequestingHostId) ? globalThis.String(object.RequestingHostId) : "",
      SessionId: isSet(object.SessionId) ? globalThis.String(object.SessionId) : "",
      RequestId: isSet(object.RequestId) ? globalThis.String(object.RequestId) : "",
    };
  },

  toJSON(message: ExecuteToolRequest): unknown {
    const obj: any = {};
    if (message.ToolId !== "") {
      obj.ToolId = message.ToolId;
    }
    if (message.Parameters?.length) {
      obj.Parameters = message.Parameters.map((e) => ToolParam.toJSON(e));
    }
    if (message.RequestingHostId !== "") {
      obj.RequestingHostId = message.RequestingHostId;
    }
    if (message.SessionId !== "") {
      obj.SessionId = message.SessionId;
    }
    if (message.RequestId !== "") {
      obj.RequestId = message.RequestId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExecuteToolRequest>, I>>(base?: I): ExecuteToolRequest {
    return ExecuteToolRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExecuteToolRequest>, I>>(object: I): ExecuteToolRequest {
    const message = createBaseExecuteToolRequest();
    message.ToolId = object.ToolId ?? "";
    message.Parameters = object.Parameters?.map((e) => ToolParam.fromPartial(e)) || [];
    message.RequestingHostId = object.RequestingHostId ?? "";
    message.SessionId = object.SessionId ?? "";
    message.RequestId = object.RequestId ?? "";
    return message;
  },
};

function createBaseToolParam(): ToolParam {
  return { Name: "", Value: "" };
}

export const ToolParam: MessageFns<ToolParam> = {
  encode(message: ToolParam, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Name !== "") {
      writer.uint32(10).string(message.Name);
    }
    if (message.Value !== "") {
      writer.uint32(18).string(message.Value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToolParam {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToolParam();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToolParam {
    return {
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      Value: isSet(object.Value) ? globalThis.String(object.Value) : "",
    };
  },

  toJSON(message: ToolParam): unknown {
    const obj: any = {};
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.Value !== "") {
      obj.Value = message.Value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ToolParam>, I>>(base?: I): ToolParam {
    return ToolParam.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToolParam>, I>>(object: I): ToolParam {
    const message = createBaseToolParam();
    message.Name = object.Name ?? "";
    message.Value = object.Value ?? "";
    return message;
  },
};

function createBaseExecuteToolResponse(): ExecuteToolResponse {
  return { Success: false, Output: "", ErrorMessage: "", OutputMessage: "", OutputFormat: "" };
}

export const ExecuteToolResponse: MessageFns<ExecuteToolResponse> = {
  encode(message: ExecuteToolResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.Output !== "") {
      writer.uint32(18).string(message.Output);
    }
    if (message.ErrorMessage !== "") {
      writer.uint32(26).string(message.ErrorMessage);
    }
    if (message.OutputMessage !== "") {
      writer.uint32(34).string(message.OutputMessage);
    }
    if (message.OutputFormat !== "") {
      writer.uint32(42).string(message.OutputFormat);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExecuteToolResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExecuteToolResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Output = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ErrorMessage = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.OutputMessage = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.OutputFormat = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExecuteToolResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Output: isSet(object.Output) ? globalThis.String(object.Output) : "",
      ErrorMessage: isSet(object.ErrorMessage) ? globalThis.String(object.ErrorMessage) : "",
      OutputMessage: isSet(object.OutputMessage) ? globalThis.String(object.OutputMessage) : "",
      OutputFormat: isSet(object.OutputFormat) ? globalThis.String(object.OutputFormat) : "",
    };
  },

  toJSON(message: ExecuteToolResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Output !== "") {
      obj.Output = message.Output;
    }
    if (message.ErrorMessage !== "") {
      obj.ErrorMessage = message.ErrorMessage;
    }
    if (message.OutputMessage !== "") {
      obj.OutputMessage = message.OutputMessage;
    }
    if (message.OutputFormat !== "") {
      obj.OutputFormat = message.OutputFormat;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExecuteToolResponse>, I>>(base?: I): ExecuteToolResponse {
    return ExecuteToolResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExecuteToolResponse>, I>>(object: I): ExecuteToolResponse {
    const message = createBaseExecuteToolResponse();
    message.Success = object.Success ?? false;
    message.Output = object.Output ?? "";
    message.ErrorMessage = object.ErrorMessage ?? "";
    message.OutputMessage = object.OutputMessage ?? "";
    message.OutputFormat = object.OutputFormat ?? "";
    return message;
  },
};

function createBaseDownloadModelRequest(): DownloadModelRequest {
  return { Model: undefined };
}

export const DownloadModelRequest: MessageFns<DownloadModelRequest> = {
  encode(message: DownloadModelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Model !== undefined) {
      AIModel.encode(message.Model, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DownloadModelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDownloadModelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Model = AIModel.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DownloadModelRequest {
    return { Model: isSet(object.Model) ? AIModel.fromJSON(object.Model) : undefined };
  },

  toJSON(message: DownloadModelRequest): unknown {
    const obj: any = {};
    if (message.Model !== undefined) {
      obj.Model = AIModel.toJSON(message.Model);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DownloadModelRequest>, I>>(base?: I): DownloadModelRequest {
    return DownloadModelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DownloadModelRequest>, I>>(object: I): DownloadModelRequest {
    const message = createBaseDownloadModelRequest();
    message.Model = (object.Model !== undefined && object.Model !== null)
      ? AIModel.fromPartial(object.Model)
      : undefined;
    return message;
  },
};

function createBaseDownloadModelResponse(): DownloadModelResponse {
  return { Success: false, ErrorMessage: "" };
}

export const DownloadModelResponse: MessageFns<DownloadModelResponse> = {
  encode(message: DownloadModelResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.ErrorMessage !== "") {
      writer.uint32(18).string(message.ErrorMessage);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DownloadModelResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDownloadModelResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ErrorMessage = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DownloadModelResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      ErrorMessage: isSet(object.ErrorMessage) ? globalThis.String(object.ErrorMessage) : "",
    };
  },

  toJSON(message: DownloadModelResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.ErrorMessage !== "") {
      obj.ErrorMessage = message.ErrorMessage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DownloadModelResponse>, I>>(base?: I): DownloadModelResponse {
    return DownloadModelResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DownloadModelResponse>, I>>(object: I): DownloadModelResponse {
    const message = createBaseDownloadModelResponse();
    message.Success = object.Success ?? false;
    message.ErrorMessage = object.ErrorMessage ?? "";
    return message;
  },
};

function createBaseRemoveModelRequest(): RemoveModelRequest {
  return { ModelId: "", ModelName: "", FileName: "" };
}

export const RemoveModelRequest: MessageFns<RemoveModelRequest> = {
  encode(message: RemoveModelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ModelId !== "") {
      writer.uint32(10).string(message.ModelId);
    }
    if (message.ModelName !== "") {
      writer.uint32(18).string(message.ModelName);
    }
    if (message.FileName !== "") {
      writer.uint32(26).string(message.FileName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveModelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveModelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ModelId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ModelName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.FileName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveModelRequest {
    return {
      ModelId: isSet(object.ModelId) ? globalThis.String(object.ModelId) : "",
      ModelName: isSet(object.ModelName) ? globalThis.String(object.ModelName) : "",
      FileName: isSet(object.FileName) ? globalThis.String(object.FileName) : "",
    };
  },

  toJSON(message: RemoveModelRequest): unknown {
    const obj: any = {};
    if (message.ModelId !== "") {
      obj.ModelId = message.ModelId;
    }
    if (message.ModelName !== "") {
      obj.ModelName = message.ModelName;
    }
    if (message.FileName !== "") {
      obj.FileName = message.FileName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveModelRequest>, I>>(base?: I): RemoveModelRequest {
    return RemoveModelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveModelRequest>, I>>(object: I): RemoveModelRequest {
    const message = createBaseRemoveModelRequest();
    message.ModelId = object.ModelId ?? "";
    message.ModelName = object.ModelName ?? "";
    message.FileName = object.FileName ?? "";
    return message;
  },
};

function createBaseRemoveModelResponse(): RemoveModelResponse {
  return { Success: false, ErrorMessage: "" };
}

export const RemoveModelResponse: MessageFns<RemoveModelResponse> = {
  encode(message: RemoveModelResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    if (message.ErrorMessage !== "") {
      writer.uint32(18).string(message.ErrorMessage);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveModelResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveModelResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ErrorMessage = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveModelResponse {
    return {
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      ErrorMessage: isSet(object.ErrorMessage) ? globalThis.String(object.ErrorMessage) : "",
    };
  },

  toJSON(message: RemoveModelResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.ErrorMessage !== "") {
      obj.ErrorMessage = message.ErrorMessage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RemoveModelResponse>, I>>(base?: I): RemoveModelResponse {
    return RemoveModelResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoveModelResponse>, I>>(object: I): RemoveModelResponse {
    const message = createBaseRemoveModelResponse();
    message.Success = object.Success ?? false;
    message.ErrorMessage = object.ErrorMessage ?? "";
    return message;
  },
};

function createBaseMcpSyncRequest(): McpSyncRequest {
  return {
    AccountId: "",
    ServerId: "",
    ServerUrl: "",
    AuthType: "",
    AuthSecret: "",
    RepositoryId: "",
    CreatedByUserId: "",
    EnabledResources: [],
  };
}

export const McpSyncRequest: MessageFns<McpSyncRequest> = {
  encode(message: McpSyncRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (message.ServerId !== "") {
      writer.uint32(18).string(message.ServerId);
    }
    if (message.ServerUrl !== "") {
      writer.uint32(26).string(message.ServerUrl);
    }
    if (message.AuthType !== "") {
      writer.uint32(34).string(message.AuthType);
    }
    if (message.AuthSecret !== "") {
      writer.uint32(42).string(message.AuthSecret);
    }
    if (message.RepositoryId !== "") {
      writer.uint32(50).string(message.RepositoryId);
    }
    if (message.CreatedByUserId !== "") {
      writer.uint32(58).string(message.CreatedByUserId);
    }
    for (const v of message.EnabledResources) {
      McpEnabledResource.encode(v!, writer.uint32(66).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): McpSyncRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMcpSyncRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ServerId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.ServerUrl = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.AuthType = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.AuthSecret = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.RepositoryId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.CreatedByUserId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.EnabledResources.push(McpEnabledResource.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): McpSyncRequest {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      ServerId: isSet(object.ServerId) ? globalThis.String(object.ServerId) : "",
      ServerUrl: isSet(object.ServerUrl) ? globalThis.String(object.ServerUrl) : "",
      AuthType: isSet(object.AuthType) ? globalThis.String(object.AuthType) : "",
      AuthSecret: isSet(object.AuthSecret) ? globalThis.String(object.AuthSecret) : "",
      RepositoryId: isSet(object.RepositoryId) ? globalThis.String(object.RepositoryId) : "",
      CreatedByUserId: isSet(object.CreatedByUserId) ? globalThis.String(object.CreatedByUserId) : "",
      EnabledResources: globalThis.Array.isArray(object?.EnabledResources)
        ? object.EnabledResources.map((e: any) => McpEnabledResource.fromJSON(e))
        : [],
    };
  },

  toJSON(message: McpSyncRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.ServerId !== "") {
      obj.ServerId = message.ServerId;
    }
    if (message.ServerUrl !== "") {
      obj.ServerUrl = message.ServerUrl;
    }
    if (message.AuthType !== "") {
      obj.AuthType = message.AuthType;
    }
    if (message.AuthSecret !== "") {
      obj.AuthSecret = message.AuthSecret;
    }
    if (message.RepositoryId !== "") {
      obj.RepositoryId = message.RepositoryId;
    }
    if (message.CreatedByUserId !== "") {
      obj.CreatedByUserId = message.CreatedByUserId;
    }
    if (message.EnabledResources?.length) {
      obj.EnabledResources = message.EnabledResources.map((e) => McpEnabledResource.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<McpSyncRequest>, I>>(base?: I): McpSyncRequest {
    return McpSyncRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<McpSyncRequest>, I>>(object: I): McpSyncRequest {
    const message = createBaseMcpSyncRequest();
    message.AccountId = object.AccountId ?? "";
    message.ServerId = object.ServerId ?? "";
    message.ServerUrl = object.ServerUrl ?? "";
    message.AuthType = object.AuthType ?? "";
    message.AuthSecret = object.AuthSecret ?? "";
    message.RepositoryId = object.RepositoryId ?? "";
    message.CreatedByUserId = object.CreatedByUserId ?? "";
    message.EnabledResources = object.EnabledResources?.map((e) => McpEnabledResource.fromPartial(e)) || [];
    return message;
  },
};

function createBaseMcpEnabledResource(): McpEnabledResource {
  return { Uri: "", Name: "", MimeType: "" };
}

export const McpEnabledResource: MessageFns<McpEnabledResource> = {
  encode(message: McpEnabledResource, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Uri !== "") {
      writer.uint32(10).string(message.Uri);
    }
    if (message.Name !== "") {
      writer.uint32(18).string(message.Name);
    }
    if (message.MimeType !== "") {
      writer.uint32(26).string(message.MimeType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): McpEnabledResource {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMcpEnabledResource();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Uri = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.MimeType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): McpEnabledResource {
    return {
      Uri: isSet(object.Uri) ? globalThis.String(object.Uri) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      MimeType: isSet(object.MimeType) ? globalThis.String(object.MimeType) : "",
    };
  },

  toJSON(message: McpEnabledResource): unknown {
    const obj: any = {};
    if (message.Uri !== "") {
      obj.Uri = message.Uri;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.MimeType !== "") {
      obj.MimeType = message.MimeType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<McpEnabledResource>, I>>(base?: I): McpEnabledResource {
    return McpEnabledResource.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<McpEnabledResource>, I>>(object: I): McpEnabledResource {
    const message = createBaseMcpEnabledResource();
    message.Uri = object.Uri ?? "";
    message.Name = object.Name ?? "";
    message.MimeType = object.MimeType ?? "";
    return message;
  },
};

function createBaseMcpSyncResponse(): McpSyncResponse {
  return { ServerId: "", Success: false, Error: "", ResourcesSynced: 0, DiscoveredResources: [] };
}

export const McpSyncResponse: MessageFns<McpSyncResponse> = {
  encode(message: McpSyncResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ServerId !== "") {
      writer.uint32(10).string(message.ServerId);
    }
    if (message.Success !== false) {
      writer.uint32(16).bool(message.Success);
    }
    if (message.Error !== "") {
      writer.uint32(26).string(message.Error);
    }
    if (message.ResourcesSynced !== 0) {
      writer.uint32(32).int32(message.ResourcesSynced);
    }
    for (const v of message.DiscoveredResources) {
      McpSyncDiscoveredResource.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): McpSyncResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMcpSyncResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ServerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Error = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.ResourcesSynced = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.DiscoveredResources.push(McpSyncDiscoveredResource.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): McpSyncResponse {
    return {
      ServerId: isSet(object.ServerId) ? globalThis.String(object.ServerId) : "",
      Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false,
      Error: isSet(object.Error) ? globalThis.String(object.Error) : "",
      ResourcesSynced: isSet(object.ResourcesSynced) ? globalThis.Number(object.ResourcesSynced) : 0,
      DiscoveredResources: globalThis.Array.isArray(object?.DiscoveredResources)
        ? object.DiscoveredResources.map((e: any) => McpSyncDiscoveredResource.fromJSON(e))
        : [],
    };
  },

  toJSON(message: McpSyncResponse): unknown {
    const obj: any = {};
    if (message.ServerId !== "") {
      obj.ServerId = message.ServerId;
    }
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    if (message.Error !== "") {
      obj.Error = message.Error;
    }
    if (message.ResourcesSynced !== 0) {
      obj.ResourcesSynced = Math.round(message.ResourcesSynced);
    }
    if (message.DiscoveredResources?.length) {
      obj.DiscoveredResources = message.DiscoveredResources.map((e) => McpSyncDiscoveredResource.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<McpSyncResponse>, I>>(base?: I): McpSyncResponse {
    return McpSyncResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<McpSyncResponse>, I>>(object: I): McpSyncResponse {
    const message = createBaseMcpSyncResponse();
    message.ServerId = object.ServerId ?? "";
    message.Success = object.Success ?? false;
    message.Error = object.Error ?? "";
    message.ResourcesSynced = object.ResourcesSynced ?? 0;
    message.DiscoveredResources = object.DiscoveredResources?.map((e) => McpSyncDiscoveredResource.fromPartial(e)) ||
      [];
    return message;
  },
};

function createBaseMcpSyncDiscoveredResource(): McpSyncDiscoveredResource {
  return { Uri: "", Name: "", MimeType: "", Description: "" };
}

export const McpSyncDiscoveredResource: MessageFns<McpSyncDiscoveredResource> = {
  encode(message: McpSyncDiscoveredResource, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Uri !== "") {
      writer.uint32(10).string(message.Uri);
    }
    if (message.Name !== "") {
      writer.uint32(18).string(message.Name);
    }
    if (message.MimeType !== "") {
      writer.uint32(26).string(message.MimeType);
    }
    if (message.Description !== "") {
      writer.uint32(34).string(message.Description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): McpSyncDiscoveredResource {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMcpSyncDiscoveredResource();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Uri = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.Name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.MimeType = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.Description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): McpSyncDiscoveredResource {
    return {
      Uri: isSet(object.Uri) ? globalThis.String(object.Uri) : "",
      Name: isSet(object.Name) ? globalThis.String(object.Name) : "",
      MimeType: isSet(object.MimeType) ? globalThis.String(object.MimeType) : "",
      Description: isSet(object.Description) ? globalThis.String(object.Description) : "",
    };
  },

  toJSON(message: McpSyncDiscoveredResource): unknown {
    const obj: any = {};
    if (message.Uri !== "") {
      obj.Uri = message.Uri;
    }
    if (message.Name !== "") {
      obj.Name = message.Name;
    }
    if (message.MimeType !== "") {
      obj.MimeType = message.MimeType;
    }
    if (message.Description !== "") {
      obj.Description = message.Description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<McpSyncDiscoveredResource>, I>>(base?: I): McpSyncDiscoveredResource {
    return McpSyncDiscoveredResource.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<McpSyncDiscoveredResource>, I>>(object: I): McpSyncDiscoveredResource {
    const message = createBaseMcpSyncDiscoveredResource();
    message.Uri = object.Uri ?? "";
    message.Name = object.Name ?? "";
    message.MimeType = object.MimeType ?? "";
    message.Description = object.Description ?? "";
    return message;
  },
};

function createBaseListenForCommandsRequest(): ListenForCommandsRequest {
  return {};
}

export const ListenForCommandsRequest: MessageFns<ListenForCommandsRequest> = {
  encode(_: ListenForCommandsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListenForCommandsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListenForCommandsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): ListenForCommandsRequest {
    return {};
  },

  toJSON(_: ListenForCommandsRequest): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<ListenForCommandsRequest>, I>>(base?: I): ListenForCommandsRequest {
    return ListenForCommandsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListenForCommandsRequest>, I>>(_: I): ListenForCommandsRequest {
    const message = createBaseListenForCommandsRequest();
    return message;
  },
};

function createBaseSendCommandRequest(): SendCommandRequest {
  return { Command: undefined };
}

export const SendCommandRequest: MessageFns<SendCommandRequest> = {
  encode(message: SendCommandRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Command !== undefined) {
      Command.encode(message.Command, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendCommandRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendCommandRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Command = Command.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendCommandRequest {
    return { Command: isSet(object.Command) ? Command.fromJSON(object.Command) : undefined };
  },

  toJSON(message: SendCommandRequest): unknown {
    const obj: any = {};
    if (message.Command !== undefined) {
      obj.Command = Command.toJSON(message.Command);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendCommandRequest>, I>>(base?: I): SendCommandRequest {
    return SendCommandRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendCommandRequest>, I>>(object: I): SendCommandRequest {
    const message = createBaseSendCommandRequest();
    message.Command = (object.Command !== undefined && object.Command !== null)
      ? Command.fromPartial(object.Command)
      : undefined;
    return message;
  },
};

function createBaseSendCommandResponse(): SendCommandResponse {
  return { Success: false };
}

export const SendCommandResponse: MessageFns<SendCommandResponse> = {
  encode(message: SendCommandResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Success !== false) {
      writer.uint32(8).bool(message.Success);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendCommandResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendCommandResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.Success = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendCommandResponse {
    return { Success: isSet(object.Success) ? globalThis.Boolean(object.Success) : false };
  },

  toJSON(message: SendCommandResponse): unknown {
    const obj: any = {};
    if (message.Success !== false) {
      obj.Success = message.Success;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SendCommandResponse>, I>>(base?: I): SendCommandResponse {
    return SendCommandResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SendCommandResponse>, I>>(object: I): SendCommandResponse {
    const message = createBaseSendCommandResponse();
    message.Success = object.Success ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
